export default __webpack_public_path__ + "static/IN-9408-vs-IN-9008_Night_resTestBig-4f4ba01657f9e79fa2cd054c493a10c2.webp";